import React from "react";
import moment from "moment";
import { getDateTimeWithFormat, isDate } from "../../../utils";

function PublicAssetTrackingLargeScreen({
  assetName,
  page,
  dataPerPage,
  todoList,
  componentList,
  isBooking, 
  setPage,
}) {
  return (
    <div>
      <h4 className="py-5 text-xl font-bold text-[#202E56] leading-5 tracking-tight">
        Equipment Overview
      </h4>
      <div className="flex items-center justify-between relative">
        <div className="w-[95%] py-4">
          <div className="w-full flex items-center justify-end">
            {/* Assets Name */}
            <div className="w-[80%] flex items-center space-x-3 flex-nowrap">
              {assetName.length > 0 &&
                assetName
                  .slice(page * dataPerPage, page * dataPerPage + dataPerPage)
                  .map((assetItem) => (
                    <div className="rounded p-2 w-[20%] h-[54px] bg-[#F2F8FF] relative">
                      <div
                        title={assetItem.asset_type}
                        className="text-center font-normal text-xs leading-4 text-[##1E293B] truncate"
                      >
                        {assetItem.asset_type}
                      </div>
                      <div
                        title={assetItem.asset_name}
                        className="text-center text-xs font-semibold leading-4 text-[##1E293B] truncate"
                      >
                        {assetItem.asset_name}
                      </div>
                    </div>
                  ))}
            </div>
          </div>
          <div className="py-4 w-full flex justify-between">
            {/* List of To Do */}
            <div className="w-[20%]">
              {todoList.length > 0 &&
                todoList.map((todoItem, index) => {
                  if (index !== todoList.length - 1) {
                    return (
                      <>
                        <div className="h-[54px] flex justify-start items-center w-3/4 bg-[#F2F8FF] rounded-md px-2">
                          <h4
                            title={todoItem.activity.todo_name}
                            className="text-sm text-[#1E293B] font-semibold leading-4 max-w-3/4 truncate"
                          >
                            {todoItem.activity.todo_name}
                          </h4>
                        </div>
                        <div className="invisible h-5"></div>
                      </>
                    );
                  }
                  return (
                    <div className="h-[54px] flex justify-start items-center w-3/4 bg-[#F2F8FF] rounded-md px-2">
                      <h4
                        title={todoItem.activity.todo_name}
                        className="text-sm text-[#1E293B] font-semibold leading-4 max-w-3/4 truncate"
                      >
                        {todoItem.activity.todo_name}
                      </h4>
                    </div>
                  );
                })}
            </div>

            {/* Status of Assets based on Asset Type */}
            <div className="w-[80%] flex items-center space-x-3 flex-nowrap">
              {assetName.length > 0 &&
                assetName
                  .slice(page * dataPerPage, page * dataPerPage + dataPerPage)
                  .map((assetItem) => (
                    <div className="w-[20%] flex justify-center relative">
                      <div className="flex flex-col items-center">
                        {todoList.length > 0 &&
                          todoList.map((todoItem, index) => {
                            const assetStatus =
                              todoItem.todo_performance_groups[
                                todoItem.todo_performance_groups.length - 1
                              ]?.todo_performances.find(
                                (data) =>
                                  data.value ===
                                  `${assetItem.asset_name}-${assetItem.asset_type}`
                              );
                            if (index !== todoList.length - 1) {
                              return (
                                <>
                                  <div
                                    className={`rounded-full border-3 w-[20px] h-[20px] relative ${
                                      assetStatus?.type === "save" ||
                                      assetStatus?.type === "complete"
                                        ? "border-indigo-500"
                                        : "border-[#D9E9FF]"
                                    }`}
                                  >
                                    <div
                                      className={`absolute top-0 left-0 h-full w-full ${
                                        assetStatus?.type === "complete"
                                          ? "bg-indigo-500 rounded"
                                          : ""
                                      } ${
                                        assetStatus?.type === "save"
                                          ? "w-1/2 bg-indigo-500 rounded-s"
                                          : ""
                                      }`}
                                    ></div>
                                  </div>

                                  <div
                                    className={`flex-auto border ${
                                      assetStatus?.type === "save" ||
                                      assetStatus?.type === "complete"
                                        ? "border-indigo-500"
                                        : "border-[#D9E9FF]"
                                    } h-[54px] w-0 transition duration-500 ease-in-out`}
                                  ></div>
                                </>
                              );
                            }
                            return (
                              <div
                                className={`rounded-full border-3 w-[20px] h-[20px] relative ${
                                  assetStatus?.type === "save" ||
                                  assetStatus?.type === "complete"
                                    ? "border-indigo-500"
                                    : "border-[#D9E9FF]"
                                }`}
                              >
                                <div
                                  className={`absolute top-0 left-0 h-full w-full ${
                                    assetStatus?.type === "complete"
                                      ? "bg-indigo-500 rounded"
                                      : ""
                                  } ${
                                    assetStatus?.type === "save"
                                      ? "w-1/2 bg-indigo-500 rounded-s"
                                      : ""
                                  }`}
                                ></div>
                              </div>
                            );
                          })}
                      </div>
                      <div className="absolute top-0 left-[65%]">
                        {todoList.length > 0 &&
                          todoList.map((todoItem, index) => {
                            if (index !== todoList.length - 1) {
                              const assetStatus =
                                todoItem.todo_performance_groups[
                                  todoItem.todo_performance_groups.length - 1
                                ]?.todo_performances.find(
                                  (data) =>
                                    data.value ===
                                    `${assetItem.asset_name}-${assetItem.asset_type}`
                                );
                              return (
                                <>
                                  <div className="h-[19px] w-[63px]">
                                    {(assetStatus?.type === "save" ||
                                      assetStatus?.type === "complete") && (
                                      <>
                                        <h4 className="text-[10px] text-[#808080] font-bold leading-4">
                                          {moment(assetStatus.date).format(
                                            "DD MMM,YYYY"
                                          )}
                                        </h4>
                                        <h6 className="text-[10px] text-[#808080] font-normal leading-4">
                                          {moment(assetStatus.date).format(
                                            "hh:mm A"
                                          )}
                                        </h6>
                                      </>
                                    )}
                                  </div>
                                  <div className="invisible h-[54px]"></div>
                                </>
                              );
                            }
                            return (
                              <div className="h-[19px] w-[63px]">
                                {(todoItem.status === "completed" ||
                                  todoItem.status === "completed with delay") &&
                                  todoItem.todo_performance_groups[
                                    todoItem.todo_performance_groups.length - 1
                                  ].todo_performances.some(
                                    (data) =>
                                      data.value ===
                                      `${assetItem.asset_name}-${assetItem.asset_type}`
                                  ) && (
                                    <>
                                      <h4 className="text-[10px] text-[#808080] font-bold leading-4">
                                        {moment(
                                          assetItem.assetPerformanceDetail[
                                            todoItem.activity.todo_name
                                          ]
                                        ).format("DD MMM,YYYY")}
                                      </h4>
                                      <h6 className="text-[10px] text-[#808080] font-normal leading-4">
                                        {moment(
                                          assetItem.assetPerformanceDetail[
                                            todoItem.activity.todo_name
                                          ]
                                        ).format("hh:mm A")}
                                      </h6>
                                    </>
                                  )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  ))}
            </div>
          </div>

          { !isBooking && (
            <div className="py-4 w-full flex justify-between">
              <div className="w-[20%] pl-5">
                {componentList.length > 0 &&
                  componentList.map((item, index) => {
                    if (index !== componentList.length - 1) {
                      return (
                        <>
                          <div className="h-[40px] flex justify-start items-center w-3/4 bg-[#F2F8FF] rounded-md px-2">
                            <h4
                              title={item.label}
                              className="text-sm text-[#1E293B] font-semibold leading-4 max-w-3/4 truncate"
                            >
                              {item.label}
                            </h4>
                          </div>
                          <div className="invisible h-5"></div>
                        </>
                      );
                    }
                    return (
                      <div className="h-[40px] flex justify-start items-center w-3/4 bg-[#F2F8FF] rounded-md px-2">
                        <h4
                          title={item.label}
                          className="text-sm text-[#1E293B] font-semibold leading-4 max-w-3/4 truncate"
                        >
                          {item.label}
                        </h4>
                      </div>
                    );
                  })}
              </div>

              <div className="w-[80%] flex items-center space-x-3 flex-nowrap">
              {assetName.length > 0 &&
                  assetName
                    .slice(page * dataPerPage, page * dataPerPage + dataPerPage)
                    .map((assetItem) => (
                      // <div className="w-full flex justify-center relative">
                      // <div className="w-full flex justify-center items-center">
                      <div className="w-[20%] flex justify-center items-center">
                          {todoList.length > 0 &&
                            todoList.map((todoItem, index) => {
                              const performanceData =
                                  todoItem.todo_performance_groups[
                                    todoItem.todo_performance_groups.length - 1
                                  ]?.todo_performances.find(
                                    (data) =>
                                      data.value ===
                                      `${assetItem.asset_name}-${assetItem.asset_type}`
                                  );

                                  return (
                                    <div className="w-full flex flex-col justify-start items-centers">
                                    {/* // <div> */}
                                      {componentList.length > 0 && 
                                      componentList.map((ele) => {
                                        const controls = performanceData?.todo_custom_controls?.find(component => component.component_id === ele.component_id);

                                        if(controls){
                                          return (
                                            <div className="">
                                              <div className="h-[40px] flex justify-start items-center bg-[#F2F8FF] rounded-md px-2">
                                                <h4
                                                  title={controls.value}
                                                  className="w-full text-sm text-[#1E293B] font-normal leading-4 line-clamp-1"
                                                >
                                                  { isDate(controls.value) ?  getDateTimeWithFormat(controls.value) : controls.value }
                                                </h4>
                                              </div>
                                              <div className="invisible h-5"></div>
                                            </div>
                                          )
                                        }

                                        const value = !performanceData && !controls  ? "pending" : "";

                                        return (
                                          <div className="flex-1 ">
                                            <div className="h-[40px] flex justify-start items-center bg-[#F2F8FF] rounded-md px-2 w-full min-w-0">
                                              <h4
                                                title={value}
                                                className="text-sm text-[#1E293B] font-normal leading-4 italic line-clamp-1"
                                              >
                                                {value}
                                              </h4>
                                            </div>
                                            <div className="invisible h-5"></div>
                                          </div>
                                        )

                                      })}
                                    </div>
                                  )
                            })}
                      </div>
                    ))}
              </div>
            </div>
          ) }

        </div>
        {/* Angular bracket icon  */}
        <div className="flex items-center space-x-2 absolute top-7 right-0">
          <span
            className={`fa-solid fa-angle-left text-base ${
              page === 0
                ? "fill-current text-slate-400 pointer-events-none"
                : "cursor-pointer"
            }`}
            onClick={(e) => setPage(page - 1)}
          ></span>
          <span
            className={`fa-solid fa-angle-right text-base ${
              Math.ceil(assetName.length / dataPerPage) === page + 1
                ? "fill-current text-slate-400 pointer-events-none"
                : "cursor-pointer"
            }`}
            onClick={(e) => setPage(page + 1)}
          ></span>
        </div>
      </div>
    </div>
  );
}

export default PublicAssetTrackingLargeScreen;
